import { ConfirmModal } from '@controlrooms/components';

interface ConfirmCloseModalProps {
  onConfirm: (closeState: boolean) => void;
  /** Use 'collection' for collection close; defaults to 'tab' */
  entityType?: 'tab' | 'collection';
}

const COPY = {
  tab: {
    title: 'Confirm to close tab',
    body: 'Are you sure you want to close this tab?',
    confirmButton: 'Close Tab',
  },
  collection: {
    title: 'Confirm to close collection',
    body: 'Are you sure you want to close this collection?',
    confirmButton: 'Close Collection',
  },
};

export const ConfirmCloseModal = ({ onConfirm, entityType = 'tab' }: ConfirmCloseModalProps) => {
  const { title, body, confirmButton } = COPY[entityType];
  return (
    <ConfirmModal
      open={true}
      title={title}
      message={body}
      confirmText={confirmButton}
      cancelText="Cancel"
      onConfirm={() => onConfirm(true)}
      onCancel={() => onConfirm(false)}
      size="sm"
    />
  );
};
